import React from 'react';

import { Pie } from '@ant-design/charts';
import { Typography } from 'antd';

import LegendDot from '../LegendDot';
import styles from './styles.module.less';

const { Text } = Typography;

export interface DistributionItem {
  key: string;
  label: string;
  note: string;
  value: number;
  /** Rounded percentage of the total. */
  percentage: number;
  color: string;
}

export interface DistributionDonutProps {
  items: DistributionItem[];
  /** Text displayed in the center of the donut. */
  centerContent: string;
  ariaLabel: string;
}

/** Donut chart with a legend listing value and share of each slice. */
const DistributionDonut: React.FC<DistributionDonutProps> = ({ items, centerContent, ariaLabel }) => (
  <div className={styles.layout}>
    <div className={styles.donut} role="img" aria-label={ariaLabel}>
      <Pie
        data={items}
        angleField="value"
        colorField="label"
        radius={0.92}
        innerRadius={0.7}
        height={196}
        color={items.map(item => item.color)}
        legend={false}
        animation={false}
        statistic={{ title: false, content: { content: centerContent } }}
      />
    </div>
    <div className={styles.list}>
      {items.map(item => (
        <div className={styles.row} key={item.key}>
          <LegendDot color={item.color} />
          <div className={styles.copy}>
            <Text strong>{item.label}</Text>
            <Text type="secondary">{item.note}</Text>
          </div>
          <div className={styles.value}>
            <Text strong>{item.value}</Text>
            <Text type="secondary">{item.percentage}%</Text>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default DistributionDonut;
